import styled from 'styled-components';
import {
  Box,
  cssColorValue,
  cssSpacing,
  semanticColors,
} from '@spotify-internal/encore-web/core';

export const StyledBox = styled(Box)`
  z-index: auto;
  cursor: initial;
`;

export const StyledTrackRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${cssSpacing('base', '24px')};
  justify-content: space-between;
`;

export const StyledTrackRowInner = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledTrackNumber = styled.div`
  margin-right: ${cssSpacing('tighter-2', '16px')};
  margin-left: -${cssSpacing('tighter-4', '8px')};
`;

export const StyledImageContainer = styled.div`
  margin-right: ${cssSpacing('tighter-3', '12px')};
  display: flex;
`;

export const StyledTrackNameDetails = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 88px;
`;

export const PillsContainer = styled.div`
  margin-bottom: ${cssSpacing('tighter-2', '16px')};
  display: flex;
`;

export const StyledNameAndExplicitTagContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const CtaContainer = styled.div`
  display: flex;
  background-color: ${cssColorValue(semanticColors.backgroundHighlight)};
  height: 316px;
  justify-content: center;
`;
